module.exports = "/dist/e50328c08c4a180a683e2dfe9c5cb7ed.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-500italic.eot
// module id = 31
// module chunks = 0